import ComponentLoader from 'components/ComponentLoader'
import React from 'react'

function loadComponent () {
  return import(/* webpackChunkName: "modules/training/modules/training-exercises/containers/ViewExercise" */ 'modules/training/modules/training-exercises/containers/ViewExercise')
}

export default function getExerciseComponentRouteUtil (props) {
  if (EXERCISE || (SERVER && global.EXERCISE)) {
    const Component = require('modules/training/modules/training-exercises/containers/ViewExercise').default
    return <Component {...props} />
  } else {
    return (
      <ComponentLoader
        loadComponent={loadComponent}
        {...props}
      />
    )
  }
}
